import { useLayoutEffect, useState } from 'react';

// Keyed on the element, not a ref: toggling a tooltip around the label remounts it.
export function useIsTextTruncated(element: HTMLElement | null, text: string): boolean {
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        if (!element) {
            return undefined;
        }
        const measure = () => {
            if (element.isConnected) {
                setIsTruncated(element.scrollWidth > element.clientWidth);
            }
        };
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [element, text]);

    return isTruncated;
}
